/**
 * Stacks flex children vertically below the md breakpoint (768px).
 * Use on table cell wrappers that lay out multiple items in a row.
 */
export const tableCellStackNarrowClassName = 'max-md:flex-col max-md:items-start';
